<div class="page article">
  <nav aria-label="Breadcrumb">
    <ol class="crumbs">
      <li><a uiSref="article">Articles</a></li>
      <li><span aria-current="page">{{ article.title }}</span></li>
    </ol>
  </nav>

  @if (alert; as a) {
    <div class="alert" [class.alert--warning]="a.kind === 'warning'" [class.alert--error]="a.kind === 'error'">
      <span class="material-icons" aria-hidden="true">{{ a.kind === 'error' ? 'visibility_off' : 'info_outline' }}</span>
      <p class="alert__text">{{ a.text }}</p>
    </div>
  }

  <article class="card article__reading">
    <header class="article__head">
      <!-- As on a forum topic: avatar, name and date first, then the title and its tags. -->
      <span class="byline">
        <a class="byline__author" uiSref="profile.about" [uiParams]="{ profileId: article.user?.slug }">
          <ut-avatar-badges class="byline__avatar" [user]="article.user" aria-hidden="true"></ut-avatar-badges>
          <span class="byline__name">{{ article.user?.name }}</span>
        </a>
        <span class="byline__when">
          @if (authorMeta) {
            {{ authorMeta }} <span aria-hidden="true">&middot;</span>&ngsp;
          }
          <time [attr.datetime]="article.published_at" [title]="article.published_at | date: 'MMM d, y, h:mm a'">{{ article.published_at | relativeDate }}</time>
        </span>
      </span>
      <h1 class="article__title">{{ article.title }}</h1>
      @if (article.tags?.length) {
        <ul class="tags" aria-label="Tags">
          @for (tag of article.tags; track tag) {
            <li><a class="tag-chip" uiSref="searchresultbytag" [uiParams]="{ contentType: 'all', query: tag }">{{ tag }}</a></li>
          }
        </ul>
      }
    </header>

    <ut-item-actions
      class="article__actions"
      [item]="article"
      [user]="user"
      [shareUrl]="article.url"
      [commentCount]="commentCount"
      (stateChanged)="refresh()">
      @if (canManage) {
        <button type="button" itemActionsEnd class="ut-btn ut-btn--secondary ut-btn--sm article__manage" aria-label="Manage article" [cdkMenuTriggerFor]="manageMenu">
          <span class="material-icons" aria-hidden="true">more_horiz</span>
        </button>
      }
    </ut-item-actions>
    <!-- Outside ut-item-actions so the menu template isn't content-projected. -->
    <ng-template #manageMenu>
      <div class="menu" cdkMenu>
        @if (article.current_user_permissions?.update) {
          <a class="menu__item" cdkMenuItem uiSref="updatearticle" [uiParams]="{ articleId: article.id }">
            <span class="material-icons" aria-hidden="true">edit</span>Edit
          </a>
        }
        @if (article.current_user_permissions?.archive) {
          <button type="button" class="menu__item" cdkMenuItem (cdkMenuItemTriggered)="toggleArchive()">
            <span class="material-icons" aria-hidden="true">archive</span>{{ article.state === 'archived' ? 'Unarchive' : 'Archive' }}
          </button>
        }
      </div>
    </ng-template>

    <div class="prose article__body" [innerHTML]="body"></div>
  </article>

  @if (article.recommendations?.length) {
    <section aria-labelledby="youMayLike">
      <h2 class="article__section-title" id="youMayLike">Articles You May Like</h2>
      <ul class="keep">
        @for (item of article.recommendations; track item.slug) {
          <li class="card keep__card">
            <span class="article__sub">{{ item.user?.name }} · {{ item.published_at | date: 'MMM d' }}</span>
            <a class="keep__title" uiSref="singlearticle" [uiParams]="{ articleId: item.slug }" [uiSrefOpts]="{ inherit: false }" (click)="trackRecommendation(item)">{{ item.title }}</a>
          </li>
        }
      </ul>
    </section>
  }

  <ut-comment-thread class="card" [service]="articleService" [commentable]="article" [user]="user" (totalChange)="threadCount.set($event)"></ut-comment-thread>
</div>
